<template>
  <div class="dashboard-list-table">
    <div v-if="loader && localAdvertisers.length === 0" class="text-center mt-4">
      <Loader
        :size="'big'"
      />
    </div>
    <template v-else-if="user">
      <div class="card shadow-none">
        <div class="card-body bg-table">
          <div class="table-responsive">
            <table class="table align-middle table-row-dashed fs-6 gy-5 bg-table">
              <thead>
              <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                <th>{{ $t('name') }}</th>
                <th width="100">
                  {{ $t('details') }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(advertiser, index) in localAdvertisers" :key="index" class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                <td class="text-black">
                    {{ advertiser.name }}
                </td>
                <td class="text-center">
                  <router-link :to="{ name: 'dashboards.advertiser.show', params: { id: advertiser.dashboard_url } }" class="link-color3"  v-b-tooltip.hover :title="$t('see_more')">
                    <i class="fa fa-eye"></i>
                  </router-link>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!--begin::Pagination-->
      <div class="text-center mb-6" v-if="localAdvertisers.length > 0 && totalPages > 1">
        <div class="d-flex flex-stack flex-wrap pt-5">
          <div class="fs-6 fw-semibold text-gray-700">
            {{ $t('pagination', { from: from, to: to, totalItems: totalItems }) }}
          </div>
          <b-pagination
            class="custom-pagination"
            v-model="page"
            :total-rows="totalItems"
            :per-page="itemsPerPage"
            :loading="loader"
            @input="getAdvertisers"
            hide-goto-end-buttons
          />
        </div>
      </div><!--end::Pagination-->
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Loader from '@/components/common/Loader/Loader'
import AdvertisersService from '@/v1/modules/advertisers/services/advertisers-service'

export default {
  name: 'AdvertiserDashboardListTable',
  props: ['advertisers', 'reload'],
  components: {
    Loader
  },
  data () {
    return {
      filters: {
      },
      from: 0,
      localAdvertisers: [],
      loader: false,
      page: 1,
      itemsPerPage: 0,
      to: 0,
      totalItems: 0,
      totalPages: 0
    }
  },
  created () {
    if (this.user) {
      this.getAdvertisers()
    } else if (this.advertisers) {
      this.localAdvertisers = this.advertisers
    }
  },
  watch: {
    reload (newValue) {
      if (newValue) this.reset()
    },
    user (newUser) {
      this.getAdvertisers()
    },
    loader (newValue) {
      this.$emit('loaderListTable', newValue)
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    /**
     * Get advertisers
     */
    async getAdvertisers () {
      if (!this.user) return false

      this.loader = true
      try {
        const advertisers = await AdvertisersService.getAdvertisers({
          category_id: this.filters.category_id,
          companyId: this.user.company.id,
          name: this.filters.name,
          status: this.filters.status,
          page: this.page,
          viewType: 'listing_basic'
        })
        this.localAdvertisers = advertisers.data
        this.totalItems = advertisers.meta.total
        this.totalPages = advertisers.meta.last_page
        this.itemsPerPage = advertisers.meta.per_page
        this.from = advertisers.meta.from
        this.to = advertisers.meta.to
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * Reset and reload
     */
    reset () {
      this.page = 1
      this.localAdvertisers = []
      this.getAdvertisers()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
